import type { ComponentProps } from "react";

import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import type { Modal } from "@similarweb/ui-components";

export const SwitchPackagePopup = styled.div`
    width: 100%;
    max-width: 580px;
    border-radius: 12px;
    background: ${colorsPalettes.carbon[0]};
    margin: auto;
`;

export const switchPackageModalStyles: ComponentProps<typeof Modal>["customStyles"] = {
    overlay: {
        backgroundColor: rgba(colorsPalettes.midnight[300], 0.7),
    },
    content: {
        width: "auto",
        background: "transparent",
        border: "none",
        padding: 0,
    },
};
